import React from 'react';
import PropTypes from 'prop-types';
import { convertToUtcDate, formatDateTime } from 'library/time';
import REDUCER_KEY from 'reducers/reducer.keys';
import { Standard } from 'components/Page';
import config from './config';

/*
 ** @description Prepare data for api
 ** @param props Object route, reference_number, carrier, departure_time, arrival_time, active
 ** @return data object
 */
const handlePrepareData = ({
  route, reference_number, carrier, departure_time, arrival_time, active
}) => ({
  route_id: route.key,
  reference_number,
  carrier,
  departure_time: formatDateTime(convertToUtcDate(departure_time), 'HH:mm'),
  arrival_time: formatDateTime(convertToUtcDate(arrival_time), 'HH:mm'),
  active
});

const Legs = ({ permissions }) => (
  <Standard
    canAdmin={permissions.CanAdminTravel()
      .hasPermissions()}
    reducer={{
      item: REDUCER_KEY.travelLeg,
      list: REDUCER_KEY.travelLegs
    }}
    config={config}
    onPrepareData={handlePrepareData}
    messaging={{
      delete: {
        disabled: () => 'Item Disabled.',
        failure: error => `Delete Failed. ${error}`,
        success: () => 'Delete Successful.'
      },
      save: {
        failure: data => `Saving Leg for route '${data.reference_number}' failed`,
        success: data => `Saving Leg for route '${data.reference_number}' was successful`
      }
    }}
  />
);

Legs.propTypes = {
  permissions: PropTypes.object.isRequired
};

export default Legs;
